import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useServerData } from '@xingternal/hops';

import { Badge, Container, Buttons, Hero } from './DownloadAppSection.style';

import appStoreBadgeDe from './images/app-store-badge-de.svg';
import appStoreBadgeEn from './images/app-store-badge-en.svg';
import appStoreBadgeIt from './images/app-store-badge-it.svg';
import appStoreBadgeFr from './images/app-store-badge-fr.svg';
import appStoreBadgeEs from './images/app-store-badge-es.svg';
import playStoreBadgeDe from './images/google-play-badge-de.svg';
import playStoreBadgeEn from './images/google-play-badge-en.svg';
import playStoreBadgeFr from './images/google-play-badge-fr.svg';
import playStoreBadgeEs from './images/google-play-badge-es.svg';
import playStoreBadgeIt from './images/google-play-badge-it.svg';

const appStoreBadge = {
  en: appStoreBadgeEn,
  de: appStoreBadgeDe,
  it: appStoreBadgeIt,
  fr: appStoreBadgeFr,
  es: appStoreBadgeEs,
};
const playStoreBadge = {
  en: playStoreBadgeEn,
  de: playStoreBadgeDe,
  fr: playStoreBadgeFr,
  es: playStoreBadgeEs,
  it: playStoreBadgeIt,
};

const DownloadAppSection = () => {
  const buttons = [
    {
      translationId: 'WELCOME_STARTPAGE_GOOGLE_PLAY_BADGE_ALT',
      href: 'https://app.adjust.com/zhz3s0l',
      image: playStoreBadge,
    },
    {
      translationId: 'WELCOME_STARTPAGE_APP_STORE_BADGE_ALT',
      href: 'https://app.adjust.com/8ppo8ep',
      image: appStoreBadge,
    },
  ];
  const { language } = useServerData();

  return (
    <Container>
      <FormattedMessage id="WELCOME_STARTPAGE_DOWNLOAD_APP_CTA">
        {text => (
          <Hero
            size="medium"
            sizeConfined="large"
            sizeWide="large"
            dangerouslySetInnerHTML={{ __html: text }}
            forwardedAs="h2"
          />
        )}
      </FormattedMessage>

      <Buttons>
        {buttons.map(({ translationId, href, image }) => (
          <FormattedMessage id={translationId} key={translationId}>
            {text => {
              const imageSrc = image[language];
              return (
                <Badge
                  href={href}
                  title={text}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={imageSrc} alt={text} loading="lazy" aria-hidden />
                </Badge>
              );
            }}
          </FormattedMessage>
        ))}
      </Buttons>
    </Container>
  );
};
export default DownloadAppSection;
